<template>
  <div>
    <loader v-if="isLoading"></loader>

    <div class="row">
      <div class="col-md-4">
        <div class="card">
          <div class="card-header"><h4>Pay Subscription</h4></div>
          <div class="card-body">
            <div class="form-group">
              <label for="plan">Select Plan</label>
              <select class="form-control" id="plan" v-model="planId">
                <option value="">Select a plan</option>
                <option v-for="plan in plans" :key="plan.id" :value="plan.id">
                  {{ plan.name }} - ${{ plan.price }}
                </option>
              </select>
              <small class="form-text text-danger" v-if="!planId && empty">
                Please select a subscription plan
              </small>
            </div>
            <div class="form-group">
              <label for="plan">Card Details</label>
              <StripeElementCard
                ref="cardRef"
                :pk="publishableKey"
                :hidePostalCode="true"
                :key="cardKey"
                @token="handleToken"
              />
            </div>
            <div class="form-group">
              <button class="btn btn-success" @click="checkout">Pay Now</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="card user-table">
          <div class="my-2">
            <input
              type="text"
              class="form-control"
              v-model="query"
              placeholder="Search..."
              @input="debouncedSearch()"
            />
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr class="table-dark-bg">
                  <th scope="col">Subscription</th>
                  <th scope="col">Payment ID</th>
                  <th scope="col">Paid Amount</th>
                  <th scope="col">Paid Date</th>
                  <th scope="col">Expiry Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="payment in payments" :key="payment.id">
                  <td>{{ payment.subscription }}</td>
                  <td>{{ payment.payment_id }}</td>
                  <td>${{ payment.paid_amount }}</td>
                  <td>
                    {{ new Date(payment.paid_date).toLocaleDateString() }}
                  </td>
                  <td>
                    {{ new Date(payment.expiry_date).toLocaleDateString() }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="row mx-1">
              <div class="col-md-3">
                <select class="form-control" v-model="currentPage">
                  <option v-for="i in lastPage" :key="i" :value="i">
                    Jump To Page {{ i }}
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <paginate
                  class="block-right"
                  containerClass="pagination"
                  pageLinkClass="page-link"
                  pageClass="page-item"
                  prev-text="Prev"
                  next-text="Next"
                  prev-link-class="page-link"
                  next-link-class="page-link"
                  :page-count="lastPage"
                  :click-handler="paginationClickHandler"
                  v-model="currentPage"
                >
                </paginate>
              </div>
              <div class="col-md-3 text-right text-muted" v-if="data">
                Showing {{ this.data.from ?? 0 }} to {{ this.data.to ?? 0 }} of
                {{ this.data.total }}
              </div>
            </div>
          </div>
          <!-- <modal name="my-first-modal"
            ><delete-modal
              resource="site"
              :id="id"
              @cancel="cancel"
              @reload-resource="reloadResource"
            />
          </modal> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/util/util";
import { StripeElementCard } from "@vue-stripe/vue-stripe";
export default {
  name: "Subscription",
  components: { StripeElementCard },
  data() {
    return {
      empty: false,
      cardKey: 0,
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      plans: [],
      planId: null,
      payments: [],
      data: null,
      siteList: [],
      isLoading: false,
      showDeleteModal: false,
      id: null,
      lastPage: 1,
      currentPage: 1,
      timer: null,
      query: "",
      catVal: "",
      qrSize: 200,
    };
  },
  mounted() {
    this.fetchPlans();
    this.fetchPayments();
  },
  methods: {
    fetchPayments() {
      this.isLoading = true;
      this.$http
        .get(`subscription-payments?page=${this.currentPage}&q=${this.query}`)
        .then((res) => {
          if (res.data.status == 1) {
            this.payments = res.data.data.data;
            this.lastPage = res.data.data.last_page;
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    paginationClickHandler(pageNum) {
      this.currentPage = pageNum;
      this.fetchPayments();
    },
    debouncedSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.currentPage = 1;
        this.fetchPayments();
      }, 500);
    },
    fetchPlans() {
      this.isLoading = true;
      util
        .http({
          url: `/plans`,
        })
        .then((res) => {
          if (res.data.status == 1) {
            this.plans = res.data.data;
            this.isLoading = false;
          } else {
            util.notify(0, res.data.errors[0]);
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.error("Error fetching subscription list:", error);
          util.notify(0, "Failed to fetch subscription list.");
          this.isLoading = false;
        });
    },
    async checkout() {
      this.empty = false;
      if (!this.planId) {
        this.empty = true;
        util.notify(0, "Please select a plan");
        return;
      }

      try {
        this.isLoading = true;

        // 1. Create PaymentIntent from Laravel
        const res = await util.http({
          method: "POST",
          url: "/create-payment-intent",
          data: {
            planId: this.planId,
          },
        });

        const clientSecret = res.data.data.clientSecret;

        // 2. Get stripe instance from component
        const stripe = this.$refs.cardRef.stripe;
        const cardElement = this.$refs.cardRef.element;

        // 3. Confirm payment
        const { error, paymentIntent } = await stripe.confirmCardPayment(
          clientSecret,
          {
            payment_method: {
              card: cardElement,
            },
          },
        );

        if (error) {
          util.notify(0, error.message);
          return;
        }

        if (paymentIntent.status === "succeeded") {
          util.notify(1, "Payment successful!");

          // 4. Activate subscription in backend
          await util.http({
            method: "POST",
            url: "/activate-subscription",
            data: {
              planId: this.planId,
              paymentIntentId: paymentIntent.id,
            },
          });
          // window.location.reload();
          // 5. Refresh payments list
          this.fetchPayments();
          this.planId = null;
          this.cardKey += 1; // Reset card element
        }
      } catch (error) {
        console.error(error);
        util.notify(0, "Payment failed");
      } finally {
        this.isLoading = false;
      }
    },
  },
  watch: {
    currentPage: function () {
      this.fetchPayments();
    },
    onPageChange(page) {
      console.log(page);
      this.currentPage = page;
    },
  },
};
</script>

<style>
#stripe-element-errors {
  color: red;
  margin-top: 10px;
}
</style>
